import {createContext, useContext} from "react";

const ConfigContext = createContext();

export default ConfigContext;

export const ConfigProvider = ({ children }) => {

    const contextData = {
        /* baseUrl: 'http://127.0.0.1:8000/', */
        baseUrl: 'https://admin.tourguidesystem.hu/',
        generalColor: 'rgba(60,128,255,0.8)',
        deliveryColor: 'rgba(48,128,42,0.58)',
        deviceColor: 'rgba(213,194,11,0.58)',
        returnColor: 'rgba(42,52,128,0.58)',
        financialColor: 'rgba(125,51,114,0.58)'
    }

    return <ConfigContext.Provider value={contextData}>{children}</ConfigContext.Provider>
}

export const useConfig = () => {
    const context = useContext(ConfigContext);
    if (!context) {
        throw new Error('useConfig must be used within a ConfigProvider');
    }
    return context;
};